import ApiClient from "shared/services/api/ApiClient";

// this works for both Axios and Spraypaint

export const isAbortError = (error: unknown): boolean =>
  (ApiClient.isApiError(error) && ApiClient.isCancel(error)) ||
  (error instanceof DOMException && error.name === "AbortError") ||
  (error instanceof Error && error.name === "CanceledError") ||
  (error as { originalError?: { name: string } })?.originalError?.name ===
    "AbortError";
